site.newsGalleryAlbum = {
	firstLoad: true,
	init: function () {
		if($('body.news .albumImagesOwl').length > 0) {
			if($('.entryImage')) {
				if(site.newsGalleryAlbum.firstLoad) {
					site.newsGalleryAlbum.setContentHeight();
					site.newsGalleryAlbum.firstLoad = false;
				}
				$(window).on('resize', function(){
					$('.entryContent').css('min-height', $('.entryImage img').height() + 30 /* margin*/);
					site.newsGalleryAlbum.setDotTopHeight();
				});
			}
			var owl = null;
			$('.albumImagesOwl img').load(function () {
				owl = site.owl.init('#news .albumImagesOwl', {
					loop: false,
					nav: true,
					items: 1,
					navText: ["<i class=\"fa fa-angle-left\"></i>", "<div class=\"arrow\"><i class=\"fa fa-angle-right\"></i></div>"],
					onInitialized: function () {
						site.newsGalleryAlbum.setDotTopHeight();
					},
					onTranslated: function () {
						site.newsGalleryAlbum.setDotTopHeight();
					},
				});
			});
			$('.owl-item').click(function() {
				owl.trigger('next.owl.carousel');
			});
			$(window).load(function() {
				site.newsGalleryAlbum.checkPortrait();
			});
		}
	},
	checkPortrait: function () {
		$('.albumImagesOwl img').each(function () {
			if($(this).prop('naturalWidth') < $(this).prop('naturalHeight')){
				$(this).addClass('portrait');
			}
		});
	},
	setContentHeight: function () {
		$('.entryImage img').load(function () {
			$('.entryContent').css('min-height', $(this).height() + 30);
		});
	},
	setDotTopHeight: function () {
		$('.albumImagesOwl .owl-dots').css('top', $('.albumImagesOwl .owl-item.active').height() + 5);
	}
};
site.inits.push('site.newsGalleryAlbum.init()');
